/*
 * Module for the Interest Batch Details And Summary report criteria page
 */
rs.module("content/reports/criteria/interestbatchdetailsandsummarycriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, sortOptions) {

            var criteria = $.js(jsSelectors.criteria);

            var detailCheckbox = criteria.js(jsSelectors.detailCheckbox);
            var sortSelect = criteria.js(jsSelectors.sortSelect);

            // Get Select Helper for sortSelect since we're updating its options and properties
            var sortSelectHelper = selectHelper.getHelper(sortSelect);

            enableDisableFields();

            // disable the sort dropdown based on the detail check box
            detailCheckbox.change(function () {
                enableDisableFields();
            });

            // Enable or disable fields
            function enableDisableFields() {

                if (detailCheckbox.is(":checked")) {
                    sortSelectHelper.setDisabled(false);
                    sortSelectHelper.replaceOptions(sortOptions);
                }
                else {
                    sortSelectHelper.clearOptions();
                    sortSelectHelper.setDisabled(true);
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);